import React from "react"; // Asegúrate de importar React para el cloneElement
import { Fab, Tooltip } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { BaseModalComponent } from "../../../common/BaseModalComponent";
import { colors } from "../../../ui/colors";

export const CustomFabModal = ({
  icon,
  tooltip = "Open modal",
  modalKey,
  modalLabel,
  children,
  size,
  color = colors.orange.base,
  placement = "left",
  directions = { bottom: 24, right: 24 },
  zIndex = 9999999,
  disabled = false,
  allowInsidePreventModal = false,
}) => {
  const fabIcon = icon ? React.cloneElement(icon, { sx: { fontSize: "1.4rem" } }) : <AddIcon sx={{ fontSize: "1.4rem" }} />;

  const fabStyle = {
    position: "absolute",
    zIndex,
    ...directions,
    width: 40,
    height: 40,
    minHeight: 40,
    boxShadow: "none",
  };

  if (disabled) {
    return (
      <Tooltip 
        title={tooltip} 
        placement={placement}
        slotProps={{
          popper: {
            sx: {
              zIndex: 15000000,
            },
          },
        }}
      >
        <span>
          <Fab
            size="small"
            disabled
            sx={{
              ...fabStyle,
              bgcolor: colors.gray[300],
              "&:hover": { bgcolor: colors.gray[300] },
            }}
          >
            {fabIcon}
          </Fab>
        </span>
      </Tooltip>
    );
  }

  return (
    <BaseModalComponent
      modalKey={modalKey}
      modalLabel={modalLabel}
      defaultSizes={size}
      allowInsidePreventModal={allowInsidePreventModal}
      elementTrigger={
        <Tooltip 
          title={tooltip} 
          placement={placement}
          slotProps={{
            popper: {
              sx: {
                zIndex: 15000000,
              },
            },
          }}
        >
          <Fab
            size="small"
            color="primary"
            sx={{
              ...fabStyle,
              bgcolor: color,
              "&:hover": {
                bgcolor: `${color}CC`,
              },
            }}
          >
            {fabIcon}
          </Fab>
        </Tooltip>
      }
    >
      {children}
    </BaseModalComponent>
  );
};
